import { createApp } from "vue";
import { setupErrorHandler } from "./utils/errorHandler";
setupErrorHandler();
import App from "./App.vue";
import router from "./router";
import store from "./store";
import i18n from "./i18n";
import BootstrapVueNext from "bootstrap-vue-next";
import { QuillEditor } from "@vueup/vue-quill";
import Vue3Prism from "vue3-prism/lib/Vue3Prism.common.js";
import { AuthService } from "./service/auth.service";
import { initializeTimezone } from "./utils/timezone";
import socketService from "./utils/socketService";
import "./utils/debugLogin";
import VueApexCharts from "vue3-apexcharts";
import "bootstrap/dist/css/bootstrap.css";
import "bootstrap-vue-next/dist/bootstrap-vue-next.css";
import "swiper/css";
import "swiper/css/bundle";
import "flatpickr/dist/flatpickr.css";
import "@vueup/vue-quill/dist/vue-quill.snow.css";
import "@vueup/vue-quill/dist/vue-quill.bubble.css";
import "vue3-prism/lib/Vue3Prism.css";
import "./assets/custom.scss";
import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";
import Toast from "vue-toastification";
import "vue-toastification/dist/index.css";
const app = createApp(App).use(router).use(store).use(i18n);
app.component("v-select", vSelect);
app.use(BootstrapVueNext);
app.use(VueApexCharts);
const options = {};
app.use(Toast, options);
app.component("QuillEditor", QuillEditor).use(Vue3Prism);
AuthService.startTokenExpirationCheck();
initializeTimezone();
socketService.connect();
// @ts-ignore
const savedLanguage = localStorage.getItem('app-language') || i18n.global.locale.value;
document.documentElement.lang = savedLanguage;
store.dispatch('language/setLanguage', savedLanguage);
app.mount("#app");
